module.exports = __webpack_public_path__ + "img/mcap.e6ddac27.svg";